// import { Injectable } from '@angular/core';
import { TmCart } from './tscapi/model/cart';
import { TmFavouriteLocalStorage } from './tscapi/model/favourite';
import { TmMenu, TmTimestamp } from './tscapi/model/menu';
import { TmTscCreditCardApplication } from './tscapi/model/tsccreditcard-application';

declare function unescape(s: string): string;
declare function escape(s: string): string;

//@Injectable()
export class Storage {
    getSessionCart(): TmCart {
        try {
            if (sessionStorage.getItem('sessionCart') != null)
                return JSON.parse(sessionStorage.getItem('sessionCart')) as TmCart;
            else return null;
        } catch (error) {
            return null;
        }
    }

    getSessionTime(): TmTimestamp {
        try {
            if (sessionStorage.getItem('timeStamp') != null)
                return JSON.parse(sessionStorage.getItem('timeStamp')) as TmTimestamp;
            else return null;
        } catch (error) {
            return null;
        }
    }
    setSessionTime(tmTimestamp: TmTimestamp): void {
        try {
            sessionStorage.setItem('timeStamp', JSON.stringify(tmTimestamp));
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    deleteSessionCart(): void {
        try {
            sessionStorage.removeItem('sessionCart');
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    setSessionCart(tmCart: TmCart): void {
        try {
            let temp = Object.assign({}, tmCart);
            temp.Buyer = null;
            temp.ShippingAddress = null;
            temp.CreditCard = null;
            sessionStorage.setItem('sessionCart', JSON.stringify(temp));
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    getSessionOrderedCart(): TmCart {
        try {
            if (sessionStorage.getItem('sessionOrderedCart') != null)
                return JSON.parse(sessionStorage.getItem('sessionOrderedCart')) as TmCart;
        } catch (error) {}
        return null;
    }

    deleteSessionOrderedCart(): void {
        try {
            sessionStorage.removeItem('sessionOrderedCart');
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    setSessionOrderedCart(tmCart: TmCart): void {
        try {
            sessionStorage.setItem('sessionOrderedCart', JSON.stringify(tmCart));
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }
    getSessionOrderModificationDeadline(): string {
        try {
            if (sessionStorage.getItem('sessionOrderModificationDeadline') != null)
                return JSON.parse(sessionStorage.getItem('sessionOrderModificationDeadline')) as string;
        } catch (error) {}
        return null;
    }

    deleteSessionOrderModificationDeadline(): void {
        try {
            sessionStorage.removeItem('sessionOrderModificationDeadline');
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    setSessionOrderModificationDeadline(strDeadline: string): void {
        try {
            sessionStorage.setItem('sessionOrderModificationDeadline', JSON.stringify(strDeadline));
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    setSessionMenu(tmMenu: TmMenu[]): void {
        try {
            sessionStorage.setItem('sessionMenu', JSON.stringify(tmMenu));
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    getSessionMenu(): TmMenu[] {
        try {
            if (sessionStorage.getItem('sessionMenu') != null)
                return JSON.parse(sessionStorage.getItem('sessionMenu')) as TmMenu[];
        } catch (error) {}
        return null;
    }

    deleteSessionMenu(): void {
        try {
            sessionStorage.removeItem('sessionMenu');
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }

    getSessionTscCreditCardApplication(): TmTscCreditCardApplication {
        try {
            let ccApplyString = localStorage.getItem('TSC_TmTscCreditCardApplication');
            if (ccApplyString != null) {
                let ccapply: TmTscCreditCardApplication = JSON.parse(ccApplyString) as TmTscCreditCardApplication;
                return ccapply;
            }
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
        return null;
    }
    setSessionTscCreditCardApplication(value: TmTscCreditCardApplication) {
        try {
            localStorage.setItem('TSC_TmTscCreditCardApplication', JSON.stringify(value));
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
    }

    getMetaEventID(): string {
        try {
            const MetaID = localStorage.getItem('TSC_MetaEventID');
            if (MetaID != null) {
                return JSON.parse(MetaID);
            }
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
        return null;
    }

    setMetaEventID(value: string) {
        try {
            localStorage.setItem('TSC_MetaEventID', JSON.stringify(value));
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
    }

    getLocalFavourites(): TmFavouriteLocalStorage[] {
        try {
            let favList = localStorage.getItem('TSC_FavouriteItem');
            if (favList != null) {
                let favourites: TmFavouriteLocalStorage[] = JSON.parse(favList) as TmFavouriteLocalStorage[];
                return favourites;
            }
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
        return null;
    }

    setLocalFavourites(value: TmFavouriteLocalStorage[]) {
        try {
            localStorage.setItem('TSC_FavouriteItem', JSON.stringify(value));
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
    }

    deleteLocalReactQueryCache(): void {
        try {
            localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE');
        } catch (error) {
            console.log('');
        }
    }

    getSessionLanguageQC(): string {
        try {
            const QC = sessionStorage.getItem('TSC_Language_QC');
            if (QC != null) {
                return QC;
            }
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
        return null;
    }

    setSessionLanguageQC(value: string) {
        try {
            sessionStorage.setItem('TSC_Language_QC', value);
        } catch (error) {
            console.log("browser doesn't support local storage");
        }
    }

    deleteSessionLanguageQC(): void {
        try {
            sessionStorage.removeItem('TSC_Language_QC');
        } catch (error) {
            console.log("browser doesn't support sessionStorage");
        }
    }
}



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../browser-storage.ts